import _ from "lodash";
import ImageRecord from "./ImageRecord";
import ApplicationRecord from "./ApplicationRecord";

export default class TeamPeople extends ApplicationRecord({
  ID: 1,
  GivenName: "",
  LastName: "",
  JobTitle: "",
  _embedded: {},
}) {
  /**
     * Give the fullName with lastname uppercased
     * Ex: Hadrien FROGER
     * @return {String}
     */
  fullname() {
    const firstName = _.trim(this.GivenName);
    const lastName = _.trim(this.LastName).toUpperCase();
    return firstName + (_.isEmpty(lastName) ? "" : " " + lastName);
  }
  /**
   * Image Profile
   * @return {ImageRecord} [description]
   */
  profile() {
    return this._getOne("ProfileImg", ImageRecord);
  }
}



// WEBPACK FOOTER //
// ./src/models/TeamPeople.js